var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfluencers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.655 10.4084L17.2418 13.5926C16.9033 13.8369 16.7521 14.2657 16.8626 14.6683L18.5904 20.9622C18.7976 21.717 17.9294 22.3045 17.3057 21.8315L12.6034 18.2652C12.2461 17.9943 11.7521 17.9943 11.3948 18.2652L6.69255 21.8315C6.06885 22.3045 5.20065 21.7169 5.40785 20.9622L7.13565 14.6683C7.24615 14.2657 7.09505 13.8369 6.75645 13.5926L2.34325 10.4084C1.70255 9.94615 2.02955 8.93405 2.81965 8.93405H8.50125C8.93905 8.93405 9.32595 8.64925 9.45605 8.23125L11.2166 2.57495C11.4556 1.80705 12.5425 1.80705 12.7815 2.57495L14.5421 8.23125C14.6722 8.64925 15.0591 8.93405 15.4969 8.93405H21.1785C21.9685 8.93405 22.2957 9.94615 21.655 10.4084Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluencers);
export default __webpack_public_path__ + "static/media/influencers.1868ea51dbd6252362eaae61a56093c5.svg";
export { ForwardRef as ReactComponent };